import { render } from "./TableGrid.vue?vue&type=template&id=0d1eaac8&scoped=true"
import script from "./TableGrid.vue?vue&type=script&lang=js"
export * from "./TableGrid.vue?vue&type=script&lang=js"

import "./TableGrid.vue?vue&type=style&index=0&id=0d1eaac8&scoped=true&lang=css"

import exportComponent from "/var/lib/buildkite-agent/builds/assemble-builder/assemble-sports/broome-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1eaac8"]])

export default __exports__